import React from 'react';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import { useStore } from '../useStore';
import AddToCart, { getTotalCartQuantity, getCartTotal } from './AddToCart';
import { cartEmpty, cartSetComment, cartSetYourReference, cartSetDeliveryInstructions, cartSetPurchaseOrderNumber } from '../reducers/cart';
import OrderIcon from '@material-ui/icons/Check';
import CartIcon from '@material-ui/icons/Clear';
import { CustomerContext } from './Context';


const CartList = ({ brewery, createOrder }) => {
  const { state, dispatch } = useStore();
  const { cart } = state;
  return (
    <Grid container direction="column" alignItems="center">
      <Grid item xs={11} sm={10} md={10} lg={10} xl={10}>
        <Grid container direction="column" alignItems="stretch" spacing={16}>
          {(!cart || (cart.items && cart.items.length === 0)) && <Typography>Inga artiklar i varukorgen.</Typography>}
          {cart && cart.items && cart.items.map(cartItem => (
            <Grid item key={cartItem.product.id}>
              <Card>
                <CardHeader title={`${cartItem.product.title} [${cartItem.product.sku}]`} />
                <CardActions>
                  <AddToCart brewery={brewery} item={cartItem.product} dispatch={dispatch} cart={cart} />
                </CardActions>
              </Card>
            </Grid>
          ))}
          {(cart && cart.items && cart.items.length &&
            <Grid item>
              <Card>
                <CardContent>
                  <Typography variant="subtitle1" color="primary" align="center">Artiklar: {getTotalCartQuantity(cart)} st, totalt: {getCartTotal(cart)} exkl. moms</Typography>
                  <Typography variant="subtitle2" align="center">Kund: <CustomerContext.Consumer>{customer => customer.company_name}</CustomerContext.Consumer></Typography>
                  <Grid container spacing={8}>
                  <Grid item xs={6}>
                    <TextField fullWidth label="Er referens" variant="outlined" value={cart.yourReference} style={{ marginBottom: '1em' }} onChange={event => dispatch(cartSetYourReference(event.target.value))} />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField fullWidth label="Inköpsordernummer" variant="outlined" value={cart.purchaseOrderNumber} style={{ marginBottom: '1em' }} onChange={event => dispatch(cartSetPurchaseOrderNumber(event.target.value))} />
                  </Grid>                
                  </Grid>
                  <TextField fullWidth multiline rows={3} variant="outlined" label="Leveransinstruktioner" value={cart.deliveryInstructions} style={{ marginBottom: '1em' }} onChange={event => dispatch(cartSetDeliveryInstructions(event.target.value))} />
                  <TextField fullWidth label="Kommentar" value={cart.comment} multiline rows={5} variant="outlined" onChange={(event) => dispatch(cartSetComment(event.target.value))} />
                  <Typography variant="h6" align="center">{brewery.info}</Typography>
                </CardContent>
                <CardActions>
                  <Grid item xs={6} style={{ textAlign: "left" }}>
                    <Button variant="contained" color="secondary" onClick={() => dispatch(cartEmpty())}><CartIcon /> Töm varukorg</Button>
                  </Grid>
                  <Grid item xs={6} style={{ textAlign: "right" }}>
                    <Button variant="contained" color="primary" onClick={() => createOrder({
                      comment: cart.comment || '',
                      your_reference: cart.yourReference,
                      delivery_instructions: cart.deliveryInstructions,
                      purchase_order_number: cart.purchaseOrderNumber,
                      items: cart.items.map(item => ({ id: item.product.id, quantity: item.quantity })),
                    })}><OrderIcon /> Lägg beställning</Button>
                  </Grid>
                </CardActions>
              </Card>
            </Grid>)
            || ''}
        </Grid>
      </Grid>
    </Grid>
  );
}

export default CartList;
